<template>
    <div class="d-flex flex-column align-center justify-center" style="height: 100vh">
        <template v-if="!errore">
            <v-progress-circular indeterminate color="primary" size="48" />
        </template>
        <template v-else>
            <p class="text-body-1 mb-4">Link non valido o non più utilizzabile.</p>
            <v-btn color="primary" :to="loginFallback">Vai al login</v-btn>
        </template>
    </div>
</template>

<script>
import { embed_login } from "@/api/api.auth.js";
import storage from "@/services/storage.js";

export default {
    name: "EmbedLoginPage",

    data() {
        return {
            errore: false,
        };
    },

    computed: {
        loginFallback() {
            return { path: "/login", query: { redirect: this.$route.query.redirect } };
        },
    },

    methods: {
        // Il redirect arriva da un parametro di query controllato da chi ha costruito
        // il link (di norma il gestionale, ma potenzialmente chiunque intercetti/modifichi
        // l'URL): deve restare un percorso interno, altrimenti "window.location =" più
        // sotto diventerebbe un open redirect (es. "//evil.com" o "javascript:...").
        destinazioneSicura(redirect) {
            if (typeof redirect === "string" && /^\/(?!\/)/.test(redirect)) return redirect;
            return "/";
        },
    },

    async mounted() {
        const token = this.$route.query.token;
        const destinazione = this.destinazioneSicura(this.$route.query.redirect);

        if (!token) {
            this.errore = true;
            return;
        }

        try {
            const resp = await embed_login(token);

            storage.setStorage(resp.data);
            storage.setEmbedMode();

            // Reload completo (non router.push): resetta lo stato Vuex, stesso
            // pattern già usato per l'impersonificazione (vedi auth.js/storage.js).
            window.location = destinazione;
        } catch (error) {
            console.log(error);
            this.errore = true;
        }
    },
};
</script>
